import React from "react";
import { Toggle } from "../shared";

const FEATURES = [
  {
    id: "send_native",
    label: "Send native currency (ETH, BNB, etc.)",
    sensitive: false,
  },
  {
    id: "send_token",
    label: "Send ERC-20 tokens (USDC, USDT, etc.)",
    sensitive: false,
  },
  {
    id: "contract_read",
    label: "Read smart contracts (free, no gas)",
    sensitive: false,
  },
  {
    id: "contract_write",
    label: "Write to smart contracts",
    sensitive: true,
  },
  {
    id: "sign_message",
    label: "Sign messages",
    sensitive: true,
  },
];

export default function FeatureToggles({ features, onToggle, disabled }) {
  return (
    <div className={`mcp-feature-toggles ${disabled ? "mcp-disabled-section" : ""}`}>
      <h5 className="mcp-subsection-title">Feature toggles</h5>
      <div className="mcp-feature-list">
        {FEATURES.map((feat) => (
          <Toggle
            key={feat.id}
            label={feat.label}
            checked={features?.[feat.id] ?? false}
            onChange={(val) => onToggle(feat.id, val)}
            disabled={disabled}
            sensitive={feat.sensitive}
          />
        ))}
      </div>
    </div>
  );
}
